/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".confirm-dialog[_ngcontent-%COMP%]{height:160px}.confirm-dialog-subtitle[_ngcontent-%COMP%]{font-weight:500;color:rgba(0,0,0,.54)}"];
export { styles as styles };
